<template>
  <lottie
    :width="width"
    :height="height"
    :options="defaultOptions"
    v-on:animCreated="handleAnimation"
  />
</template>

<script>
import Lottie from 'vue-lottie'

export default {
  props: {
    json: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
    },
    speed: {
      type: Number,
      default: 1,
    },
    width: {
      type: Number,
      default: 256,
    },
    height: {
      type: Number,
      default: 256,
    },
  },
  components: {
    Lottie,
  },
  data() {
    return {
      defaultOptions: { animationData: this.json },
    }
  },
  mounted() {
    if (this.options) this.defaultOptions = this.options
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim
    },

    stop: function () {
      this.anim.stop()
    },

    play: function () {
      this.anim.play()
    },

    pause: function () {
      this.anim.pause()
    },

    onSpeedChange: function () {
      this.anim.setSpeed(this.speed)
    },
  },
}
</script>

<style lang="scss">
.lottie {
  width: 100%;
  height: 100%;
}
</style>
